import React from 'react'
import CSSModules from 'react-css-modules'
import { IconButton } from 'react-toolbox/lib/button'

import theme from './SideNavIconButton.scss'

const SideNavIconButton = (props) => (
  <IconButton icon={props.icon} primary theme={theme}/>
)

export default CSSModules(SideNavIconButton, theme)
